<div class="req-page">
  <button type="button" class="req-back" (click)="goBack()">
    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12 4l-6 6 6 6"/></svg>
    {{ backLabel }}
  </button>

  <div *ngIf="loadingRequest" class="pp-card"><div class="pp-loading">{{ t('common.loading', 'Загрузка...') }}</div></div>
  <div *ngIf="errorRequest" class="pp-card"><div class="pp-error" role="alert">{{ errorRequest }}</div></div>

  <ng-container *ngIf="request as r">
    <!-- Шапка: номер, маршрут крупно, статус и главное действие -->
    <header class="req-head">
      <div class="req-head__titles">
        <div class="req-head__meta">
          <span class="req-head__num">{{ t('ffRequest.title', 'Запрос') }} {{ requestNo(r) }}</span>
          <span class="rate-pill">{{ rateLabel(r.rateType) }}</span>
        </div>
        <h1>{{ r.fromCity }} <span class="arrow" aria-hidden="true">→</span> {{ r.toCity }}</h1>
        <p class="req-head__sub">
          {{ countryName(r.fromCountryId) }} → {{ countryName(r.toCountryId) }}
        </p>
      </div>
      <div class="req-head__actions">
        <button #chatBtn type="button" class="pp-btn pp-btn--primary chat-btn" [class.chat-btn--active]="chatOpen && !chatClosing" (click)="chatOpen ? closeChat() : openChat(chatBtn)">
          <svg class="chat-btn__logo" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3z"/><circle cx="8.2" cy="12" r="1.1"/><circle cx="12" cy="12" r="1.1"/><circle cx="15.8" cy="12" r="1.1"/></svg>
          {{ t('ffRequest.chat', 'Чат с клиентом') }}
          <span class="chat-btn__badge" *ngIf="unreadCount > 0" [attr.title]="t('ffRequest.newMessages', 'Новых сообщений: {n}').replace('{n}', '' + unreadCount)">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
        </button>
      </div>
    </header>

    <div class="req-assign" *ngIf="companyContext.company && (companyContext.hasPermission('ASSIGN_REQUESTS') || r.forwarderManagerName)">
      <app-assignee-select kind="forwarderManager" [entityId]="r.id" [currentId]="r.forwarderManagerId"
                           [currentName]="r.forwarderManagerName"
                           [canEdit]="companyContext.hasPermission('ASSIGN_REQUESTS')"
                           (assigned)="onForwarderManagerAssigned($event)"></app-assignee-select>
    </div>

    <!-- Ставка принята — поздравление и переход к сделке, сразу видно при открытии -->
    <section class="won-banner" *ngIf="myBid?.bidStatus === 'ACCEPTED' && r.dealId">
      <div class="won-banner__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>
      </div>
      <div class="won-banner__text">
        <strong>{{ t('ffRequest.wonTitle', 'Поздравляем!') }} {{ t('ffRequest.wonDate', 'Клиент выбрал вашу ставку {date}.').replace('{date}', ((myBid?.updatedAt || myBid?.createdAt) | date:'dd.MM.yyyy') || '') }}</strong>
        <span>{{ t('ffRequest.wonText', 'Создано окно сделки — там документы, этапы перевозки и чат с клиентом.') }}</span>
      </div>
      <a class="pp-btn pp-btn--primary won-banner__btn" [routerLink]="['/freight-forwarder/deal', r.dealId]">
        {{ t('ffRequest.goToDeal', 'Перейти к сделке') }} {{ r.dealId | docNo:'D' }}
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
      </a>
    </section>

    <!-- Ставку не выбрали — спокойная плашка вверху страницы и путь к новым запросам -->
    <section class="won-banner won-banner--lost" *ngIf="myBid?.bidStatus === 'LOST'">
      <div class="won-banner__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M12 7v6M12 16.5v.1"/></svg>
      </div>
      <div class="won-banner__text">
        <strong>{{ t('ffRequest.lostTitle', 'Клиент выбрал другого перевозчика') }}</strong>
        <span>{{ t('ffRequest.lostText', 'Спасибо за ставку! Новые запросы появляются каждый день — следующий может стать вашим.') }}</span>
      </div>
      <a class="pp-btn pp-btn--ghost won-banner__btn" routerLink="/freight-forwarder/requests">
        {{ t('ffRequest.findRequests', 'Найти новые запросы') }}
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
      </a>
    </section>

    <div class="req-grid">
      <div class="req-col">
        <!-- Маршрут и сроки -->
        <section class="pp-card req-card">
          <div class="ship-head">
            <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>{{ t('ffRequest.shipping', 'Перевозка') }}</h2>
          <button type="button" class="copy-btn" [attr.title]="t('ffRequest.copyForMessenger', 'Скопировать для мессенджеров')" [class.is-done]="copied" (click)="copyForMessenger()">
            <svg *ngIf="!copied" viewBox="0 0 20 20" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2"/><path d="M13 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/></svg>
            <svg *ngIf="copied" viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>
            {{ copied ? t('ffRequest.copied', 'Скопировано') : t('ffRequest.copy', 'Скопировать') }}
          </button>
          </div>
          <div class="ship-row">
          <dl class="facts facts--spread facts--ship">
            <div>
              <dt>{{ t('ffRequest.transport', 'Тип перевозки') }}</dt>
              <dd>{{ rateLabel(r.rateType) }}</dd>
            </div>
            <div *ngIf="r.createdAt">
              <dt>{{ t('ffRequest.published', 'Опубликован') }}</dt>
              <dd>{{ r.createdAt | date:'dd.MM.yyyy' }}</dd>
            </div>
            <div>
              <dt>{{ t('freightForwarder.requests.loadingDate', 'Дата погрузки') }}</dt>
              <dd>{{ r.loadingDate | date:'dd.MM.yyyy' }}</dd>
            </div>
            <div>
              <dt>{{ t('ffRequest.totalWeight', 'Общий вес') }}</dt>
              <dd>{{ fmtWeight(totalWeight) }}</dd>
            </div>
            <div>
              <dt>{{ t('ffRequest.totalVolume', 'Общий объём') }}</dt>
              <dd>{{ fmtVolume(totalVolume) }}</dd>
            </div>
            <div>
              <dt>{{ t('freightForwarder.requests.price', 'Стоимость груза') }}</dt>
              <dd>{{ fmtMoney(r.price, currencyCode(r.currencyId)) }}</dd>
            </div>
          </dl>
          <!-- Особенности груза: если флаг не стоит — пишем обратное, чтобы экспедитор видел явный ответ -->
          <ul class="cargo-traits">
            <li *ngFor="let f of cargoTraits" [class.is-on]="f.on" [class.is-warn]="f.on && f.warn">
              <svg *ngIf="f.on" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M10 3.5l7 12.5H3z M10 8.5v3.5 M10 14.2v.1"/>
              </svg>
              {{ f.label }}
            </li>
          </ul>
          </div>
        </section>

        <!-- Грузовые места: каждый параметр подписан -->
        <section class="pp-card req-card">
          <div class="req-card__head">
            <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg></span>{{ t('ffRequest.itemsTitle', 'Грузовые места') }}</h2>
            <span class="items-total">{{ t('ffRequest.itemsTotal', 'Всего: {n}').replace('{n}', '' + placesCount) }}</span>
          </div>
          <ul class="items">
            <li *ngFor="let p of r.products; let i = index" class="item">
              <div class="item__head">
                <span class="item__num">{{ i + 1 }}</span>
                <strong>{{ p.name || cargoTypeName(p.cargoTypeId) || t('ffRequest.item', 'Груз') }}</strong>
                <span class="item__icons" *ngIf="p.isDangerous || p.isOversized || p.isNonStackable">
                  <span class="item-icon item-icon--warn" *ngIf="p.isDangerous" [attr.title]="t('ffSearch.dangerous', 'Опасный груз')" [attr.aria-label]="t('ffSearch.dangerous', 'Опасный груз')">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 3.5l7 12.5H3z M10 8.5v3.5 M10 14.2v.1"/></svg>
                  </span>
                  <span class="item-icon item-icon--warn" *ngIf="p.isOversized" [attr.title]="t('ffSearch.oversized', 'Крупногабаритный груз')" [attr.aria-label]="t('ffSearch.oversized', 'Крупногабаритный груз')">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 7V3h4 M13 3h4v4 M17 13v4h-4 M7 17H3v-4 M3 3l5 5 M17 3l-5 5 M17 17l-5-5 M3 17l5-5"/></svg>
                  </span>
                  <span class="item-icon" *ngIf="p.isNonStackable" [attr.title]="t('ffSearch.nonStackable', 'Не штабелировать')" [attr.aria-label]="t('ffSearch.nonStackable', 'Не штабелировать')">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><rect x="5" y="11" width="10" height="6" rx="1"/><rect x="5" y="3" width="10" height="6" rx="1"/><path d="M3 2l14 16"/></svg>
                  </span>
                </span>
              </div>
              <dl class="item__grid">
                <div>
                  <dt>{{ t('ffRequest.itemPlaces', 'Количество мест') }}</dt>
                  <dd>{{ p.quantity || 1 }}</dd>
                </div>
                <div>
                  <dt>{{ t('ffSearch.weight', 'Вес') }}</dt>
                  <dd>{{ fmtWeight(p.totalWeightKg) }}</dd>
                </div>
                <div *ngIf="productVolume(p)">
                  <dt>{{ t('ffSearch.volume', 'Объём') }}</dt>
                  <dd>{{ fmtVolume(productVolume(p)) }}</dd>
                </div>
                <div *ngIf="p.lengthMm && p.widthMm && p.heightMm">
                  <dt>{{ t('ffRequest.itemSize', 'Размер места, мм') }}</dt>
                  <dd>{{ p.lengthMm }} × {{ p.widthMm }} × {{ p.heightMm }}</dd>
                </div>
                <div *ngIf="p.tnvedCode">
                  <dt>{{ t('ffRequest.tnved', 'Код ТНВЭД') }}</dt>
                  <dd>{{ p.tnvedCode }}</dd>
                </div>
              </dl>
            </li>
          </ul>
        </section>
      </div>

      <!-- Моя ставка -->
      <aside class="pp-card req-card bid-card">
        <!-- Заголовок и статус рядом: «Принимает ставки» или статус моей ставки -->
        <div class="bid-card__head">
          <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg></span>{{ myBidSectionTitleText }}</h2>
          <span class="pp-badge" *ngIf="!loadingBid && myBid" [ngClass]="'pp-badge--' + bidTone()">{{ getBidStatusText() }}</span>
          <span class="pp-badge" *ngIf="!loadingBid && !myBid" [ngClass]="'pp-badge--' + pageStatus.tone">{{ pageStatus.text }}</span>
        </div>
        <div *ngIf="loadingBid" class="muted">{{ loadingBidText }}</div>
        <div *ngIf="errorBid" class="pp-error bid-error" role="alert">{{ errorBid }}</div>

        <ng-container *ngIf="!loadingBid && !myBid">
          <p class="muted" *ngIf="!r.hasDeal">{{ t('ffRequest.noBidHint', 'Предложите цену и срок — клиент сравнит ставки и выберет перевозчика.') }}</p>
          <p class="muted" *ngIf="r.hasDeal">{{ t('ffRequest.closedHint', 'Клиент уже выбрал перевозчика — ставки больше не принимаются.') }}</p>
          <button type="button" class="pp-btn pp-btn--primary bid-card__cta" *ngIf="!r.hasDeal" (click)="makeBid()">{{ makeBidText }}</button>
        </ng-container>

        <ng-container *ngIf="!loadingBid && myBid as b">
          <p class="bid-no">{{ t('ffRequest.bidNo', 'Ставка') }} <strong>{{ b.id | docNo:'B':b.createdAt }}</strong></p>
          <div class="bid-price">
            <small>{{ priceText }}</small>
            <strong>{{ fmtMoney(b.price, b.currencyCode) }}</strong>
          </div>
          <!-- После решения клиента — место нашей цены среди всех ставок -->
          <p class="price-rank" *ngIf="b.pricePosition && (b.bidStatus === 'LOST' || b.bidStatus === 'ACCEPTED')" [class.price-rank--best]="b.pricePosition === 1">
            {{ priceRankText(b.pricePosition) }}
          </p>
          <dl class="facts facts--stack">
            <div>
              <dt>{{ deliveryDaysText }}</dt>
              <dd>{{ b.deliveryDays }} {{ daysText }}</dd>
            </div>
            <div *ngIf="b.services?.length">
              <dt>{{ servicesText }}</dt>
              <dd class="wrap">{{ getServiceNames(b) }}</dd>
            </div>
            <div *ngIf="b.createdAt">
              <dt>{{ t('ffRequest.sentAt', 'Отправлена') }}</dt>
              <dd>{{ b.createdAt | date:'dd.MM.yyyy HH:mm' }}</dd>
            </div>
          </dl>

          <!-- Подробнее: всё остальное по ставке, раскрывается по кнопке -->
          <ng-container *ngIf="hasBidDetails(b)">
            <dl class="facts facts--stack bid-more" *ngIf="bidExpanded">
              <div *ngIf="b.note">
                <dt>{{ noteText }}</dt>
                <dd class="wrap">{{ b.note }}</dd>
              </div>
              <div *ngIf="b.updatedAt && b.updatedAt !== b.createdAt">
                <dt>{{ t('ffRequest.updatedAt', 'Изменена') }}</dt>
                <dd>{{ b.updatedAt | date:'dd.MM.yyyy HH:mm' }}</dd>
              </div>
            </dl>
            <button type="button" class="bid-toggle" [class.is-open]="bidExpanded" (click)="bidExpanded = !bidExpanded" [attr.aria-expanded]="bidExpanded">
              {{ bidExpanded ? t('ffRequest.collapse', 'Свернуть') : t('ffRequest.more', 'Подробнее') }}
              <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 8l5 5 5-5"/></svg>
            </button>
          </ng-container>
          <div class="bid-card__actions" *ngIf="canEditBid()">
            <button type="button" class="pp-btn pp-btn--primary" (click)="editBid()">{{ t('ffRequest.editBid', 'Изменить ставку') }}</button>
            <button type="button" class="pp-btn pp-btn--ghost bid-delete" (click)="deleteBid()" [disabled]="deletingBid">
              {{ deletingBid ? deletingBidText : deleteBidText }}
            </button>
          </div>
          <ng-container *ngIf="b.bidStatus === 'ACCEPTED' && r.dealId; else bidInfo"></ng-container>
          <ng-template #bidInfo>
            <ng-container *ngIf="b.bidStatus === 'LOST'; else otherInfo"></ng-container>
            <ng-template #otherInfo>
              <p class="muted" *ngIf="!canEditBid()">{{ getBidInfoText() }}</p>
            </ng-template>
          </ng-template>
        </ng-container>
      </aside>
    </div>

    <!-- Чат с клиентом — окно-мессенджер, вылетает из кнопки и сворачивается в неё (на телефоне — на весь экран) -->
    <div class="chat-backdrop" *ngIf="chatOpen" [class.is-closing]="chatClosing" (click)="closeChat()"></div>
    <aside class="chat-panel" *ngIf="chatOpen && chatBox as box" [class.is-closing]="chatClosing"
           [style.top.px]="box.top" [style.left.px]="box.left" [style.width.px]="box.width" [style.height.px]="box.height"
           [style.transform-origin]="box.origin"
           role="dialog" aria-modal="true" [attr.aria-label]="t('ffRequest.chat', 'Чат с клиентом')">
      <header class="chat-panel__head">
        <span class="chat-panel__avatar" aria-hidden="true">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="8.5" r="3.6"/><path d="M5 19.5c1.2-3.4 3.9-5 7-5s5.8 1.6 7 5"/></svg>
        </span>
        <div class="chat-panel__titles">
          <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 21V8l9-5 9 5v13"/><path d="M9 21v-6h6v6"/></svg></span>{{ t('ffRequest.client', 'Клиент') }}</h2>
          <p>{{ t('ffRequest.title', 'Запрос') }} {{ requestNo(r) }} · {{ r.fromCity }} → {{ r.toCity }}</p>
        </div>
        <button type="button" class="chat-panel__close" (click)="closeChat()" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
      </header>
      <div class="chat-panel__body">
        <app-chat contextType="REQUEST" [contextId]="r.id" [locked]="baseRequestHasDeal"></app-chat>
      </div>
    </aside>
  </ng-container>
</div>

<!-- Телефон: главное действие всегда под рукой -->
<div class="sticky-cta" *ngIf="request && primaryAction">
  <button type="button" class="pp-btn pp-btn--primary" (click)="onPrimaryAction()">
    {{ primaryAction === 'make' ? makeBidText : t('ffRequest.editBid', 'Изменить ставку') }}
  </button>
</div>
